<template>
  <div class="bulk-order-suggest-banner">
    <ImgLazy
      :image-url="bulkOrderSuggestImagePath"
      alt-text="まとめてオーダー"
      aspect-ratio="57 / 53"
      class="bulk-order-suggest-banner__icon"
    />
    <p class="bulk-order-suggest-banner__text">
      11名以上へギフトカードをまとめて購入したい方は、まとめてオーダーがおすすめです！
    </p>
    <div class="bulk-order-suggest-banner__buttons">
      <template v-if="fulfillment">
        <div class="bulk-order-suggest-banner__button">
          <ButtonSecondary
            text="URL形式の詳細を見る"
            size="small"
            @click-secondary-button="onClickUrlDetail"
          />
        </div>
        <div class="bulk-order-suggest-banner__button">
          <ButtonSecondary
            text="カード形式の詳細を見る"
            size="small"
            @click-secondary-button="onClickFulfillmentDetail"
          />
        </div>
      </template>
      <div
        v-else
        class="bulk-order-suggest-banner__button bulk-order-suggest-banner__button--full"
      >
        <ButtonSecondary
          text="詳しく見る"
          size="small"
          @click-secondary-button="onClickUrlDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'
import ButtonSecondary from '../../molecules/buttons/ButtonSecondary.vue'
import PersonalBulkOrderSuggest from '../../../../../images/personal-bulk-order-suggest.png'

export default {
  name: 'BulkOrderSuggestBanner',
  components: {
    ImgLazy,
    ButtonSecondary
  },
  props: {
    fulfillment: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    bulkOrderSuggestImagePath() {
      return PersonalBulkOrderSuggest
    }
  },
  methods: {
    onClickUrlDetail() {
      this.$emit('click-url-detail')
    },
    onClickFulfillmentDetail() {
      this.$emit('click-fulfillment-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.bulk-order-suggest-banner {
  background-color: $primary-lighten;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 128px 1fr;
  grid-template-rows: auto auto;
  column-gap: 16px;
  row-gap: 8px;
  padding: 16px;
  box-sizing: border-box;

  &__icon {
    width: 128px;
    height: 82px;
    grid-column: 1;
    grid-row: 1 / 3;
  }

  &__text {
    grid-column: 2;
    grid-row: 1;
    align-self: end;
    font-size: 1.2rem;
    line-height: 1.6;
    font-weight: bold;
    color: $brown-1;
    margin: 0;
  }

  &__buttons {
    grid-column: 2;
    grid-row: 2;
    display: flex;
    justify-content: flex-start;
    align-self: start;
    gap: 8px;
  }

  &__button {
    flex-shrink: 0;

    // ButtonBase の width: 100% を上書きし、コンテンツ幅で横並びにする
    :deep(.btn) {
      width: auto;
    }
  }

  @media all and (max-width: ($base-contents-width - 1px)) {
    grid-template-columns: 57px 1fr;
    column-gap: 12px;
    row-gap: 16px;
    padding: 16px 8px;

    &__icon {
      width: 57px;
      height: auto;
      grid-row: 1;
    }

    &__text {
      align-self: center;
    }

    &__buttons {
      grid-column: 1 / -1;
      justify-content: center;
    }

    // 単独ボタン時は SP のみ全幅
    &__button--full,
    &__button--full :deep(.btn) {
      width: 100%;
    }
  }
}
</style>
